var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ul",
    { staticClass: "grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" },
    _vm._l(_vm.items, function (item) {
      return _c(
        "li",
        { key: item.id, staticClass: "col-span-1 bg-white rounded-lg shadow" },
        [
          _c(
            "div",
            {
              staticClass:
                "w-full flex items-center justify-between p-6 space-x-6",
            },
            [
              _c("div", { staticClass: "flex-1 truncate" }, [
                _c("div", { staticClass: "flex items-center space-x-3" }, [
                  _c(
                    "h3",
                    {
                      staticClass:
                        "text-gray-900 text-sm leading-5 font-medium truncate",
                    },
                    [
                      _vm._v(
                        _vm._s(item.user.given_name) +
                          " " +
                          _vm._s(item.user.family_name)
                      ),
                    ]
                  ),
                ]),
                _c(
                  "p",
                  {
                    staticClass:
                      "mt-1 text-gray-500 text-sm leading-5 truncate",
                  },
                  [
                    _vm._v(
                      _vm._s(
                        item.user.profile
                          ? item.user.profile.occupation || "-"
                          : "-"
                      )
                    ),
                  ]
                ),
              ]),
              item.user.avatar
                ? [
                    _c("s3-image", {
                      staticClass:
                        "w-10 h-10 bg-gray-300 rounded-full flex-shrink-0",
                      attrs: { s3FileKey: item.user.avatar, alt: "" },
                    }),
                  ]
                : [
                    _c(
                      "div",
                      {
                        staticClass:
                          "h-10 w-10 rounded-full overflow-hidden bg-gray-100",
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "inline-flex items-center justify-center h-10 w-10 rounded-full",
                            style: `background-color: ${_vm.initialColor()}`,
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "text-lg font-medium leading-none text-white",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    item.user.given_name[0] +
                                      item.user.family_name[0]
                                  )
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
            ],
            2
          ),
          _c("div", { staticClass: "border-t border-gray-200" }, [
            _c("div", { staticClass: "-mt-px flex" }, [
              _c(
                "div",
                { staticClass: "w-0 flex-1 flex border-r border-gray-200" },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm leading-5 text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500 focus:outline-none focus:border-primary focus:z-10 transition ease-in-out duration-150",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.message(item.user.id)
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "w-5 h-5 text-gray-400",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z",
                            },
                          }),
                        ]
                      ),
                      _c("span", { staticClass: "ml-3" }, [_vm._v("Message")]),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }